import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLettersIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.4375 15V4.875H1.5V3H11.25V4.875H7.3125V15H5.4375ZM12.1875 15V8.625H9.75V6.75H16.5V8.625H14.0625V15H12.1875Z",
		fill: "#3C59F6"
	})
});
export default SvgLettersIcon;
